module.exports = __webpack_public_path__ + "img/5.0d1c8694.png";